import MainLayout from '@/components/layout/MainLayout.vue';

export default {
    name: 'termsOfService',

    components: {
        MainLayout
    }
}